import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { startWith } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TickService implements OnDestroy {
  private readonly _secondsIntervalId: any | undefined;
  private readonly _minutesIntervalId: any | undefined;
  private readonly _hoursIntervalId: any | undefined;
  private readonly _seconds$ = new Subject<Date>();
  private readonly _fiveSeconds$ = new Subject<Date>();
  private readonly _tenSeconds$ = new Subject<Date>();
  private readonly _fifteenSeconds$ = new Subject<Date>();
  private readonly _thirtySeconds$ = new Subject<Date>();
  private readonly _minutes$ = new Subject<Date>();
  private readonly _fiveMinutes$ = new Subject<Date>();
  private readonly _tenMinutes$ = new Subject<Date>();
  private readonly _hours$ = new Subject<Date>();

  constructor() {
    let seconds = 0;
    this._secondsIntervalId = setInterval(() => {
      seconds++;
      const now = new Date();
      this._seconds$.next(now);

      if (seconds % 5 === 0) {
        this._fiveSeconds$.next(now);
      }
      if (seconds % 10 === 0) {
        this._tenSeconds$.next(now);
      }
      if (seconds % 15 === 0) {
        this._fifteenSeconds$.next(now);
      }
      if (seconds % 30 === 0) {
        this._thirtySeconds$.next(now);
      }
    }, 1000);

    let minutes = 0;
    this._minutesIntervalId = setInterval(() => {
      minutes++;
      const now = new Date();
      this._minutes$.next(now);
      if (minutes % 5 === 0) {
        this._fiveMinutes$.next(now);
      }
      if (minutes % 10 === 0) {
        this._tenMinutes$.next(now);
      }
    }, 60 * 1000);

    let hours = 0;
    this._hoursIntervalId = setInterval(() => {
      hours++;
      const now = new Date();
      this._hours$.next(now);
    }, 60 * 60 * 1000);
  }

  get seconds$() {
    return this._seconds$.asObservable().pipe(startWith(new Date()));
  }

  get everyFiveSeconds$() {
    return this._fiveSeconds$.asObservable().pipe(startWith(new Date()));
  }

  get everyTenSeconds$() {
    return this._tenSeconds$.asObservable().pipe(startWith(new Date()));
  }

  get everyFifteenSeconds$() {
    return this._fifteenSeconds$.asObservable().pipe(startWith(new Date()));
  }

  get everyThirtySeconds$() {
    return this._thirtySeconds$.asObservable().pipe(startWith(new Date()));
  }

  get everyMinute$() {
    return this._minutes$.asObservable().pipe(startWith(new Date()));
  }

  get everyFiveMinutes$() {
    return this._fiveMinutes$.asObservable().pipe(startWith(new Date()));
  }

  get everyTenMinutes$() {
    return this._tenMinutes$.asObservable().pipe(startWith(new Date()));
  }

  get everyHour$() {
    return this._hours$.asObservable().pipe(startWith(new Date()));
  }

  ngOnDestroy() {
    clearInterval(this._secondsIntervalId);
    clearInterval(this._minutesIntervalId);
    clearInterval(this._hoursIntervalId);
  }
}
